import { Card } from '@mui/material';

export const AssessmentCard = ({ children }) => (
  <Card sx={{ p: 3, mb: 2 }}>{children}</Card>
);
